import React, { useEffect, useState } from 'react'
import { BiTime } from 'react-icons/bi';
import { getPriorityColor } from '../../../../utils/Helper';
import { useNavigate } from 'react-router-dom';
import axiosAuthInstance from '../../../../utils/axios/axiosAuthInstance';
import Select from "react-select";

const NotAssignedTask = ({ reload }) => {
  const navigate = useNavigate();
  const [unassignedTasks, setUnassignedTasks] = useState([])
  const [teamMembers, setTeamMembers] = useState([])
  const [selectedMember, setSelectedMember] = useState({})

  const fetchTaskData = async () => {
    try {
      const response = await axiosAuthInstance.get('task/list', { notAssign: true })

      if (response && response.status === 200) {
        setUnassignedTasks(response.data?.result?.docs)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  const fetchTeamMembers = async () => {
    try {
      const response = await axiosAuthInstance.get('team/dropdown', { isTeamLeader: true })
      if (response.status === 200) {
        const transformedData = response?.data?.result?.map((item) => ({
          value: item._id,
          label: `${item.full_name}`,
        }))
        setTeamMembers(transformedData)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleTaskClick = (id) => {
    navigate(`/task/view/${id}`)
  }

  const handleMemberChange = async (selectedOption, taskId) => {
    setSelectedMember(prevState => ({
      ...prevState,
      [taskId]: selectedOption ? selectedOption.value : ""
    }));

    try {
      const response = await axiosAuthInstance.put(`task/assign/${taskId}`, { assignTo: selectedOption?.value })
      if (response.status === 200) {
        fetchTaskData()
        reload()
      }
    } catch (error) {
      console.log('error', error)
    }
  };

  useEffect(() => {
    fetchTaskData()
    fetchTeamMembers()
  }, [])

  return (
    <div className="space-y-4 mt-4">
      <h2 className="text-xl font-semibold flex items-center gap-2">
        <BiTime className="text-gray-600" />
        Not Assigned Tasks To Team
      </h2>
      <div className="bg-white rounded-lg shadow-sm p-4 space-y-3 overflow-auto max-h-80">
        {unassignedTasks?.length > 0 ? unassignedTasks.map(task => (
          <div
            key={task._id}
            className="flex items-center justify-between py-3 border-b last:border-0 cursor-pointer hover:bg-gray-50"
          >
            <div>
              <span className="text-gray-700" onClick={() => handleTaskClick(task._id)}>{task.name}</span>
              <span className={`mx-3 px-3 py-1 rounded-full text-sm ${getPriorityColor(task.priority)}`}>
                {task.priority}
              </span>
            </div>
            <Select
              id="employee"
              value={teamMembers.find((option) => option.value === selectedMember[task._id])}
              onChange={(selectedOption) => handleMemberChange(selectedOption, task._id)}
              options={teamMembers}
              placeholder="Assign To"
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>
        )) : "No Tasks"}

      </div>
    </div>
  )
}

export default NotAssignedTask

